var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:{'eyes': 1, 'open': _vm.isHereSomebodyElse},attrs:{"title":_vm.getUsers}},[_c('b-icon',{attrs:{"icon":"eye","variant":"warning"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }